var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ement_wrap",style:({
    backgroundColor: ("" + (_vm.options.style.bgColor)),
    fontSize: ((_vm.options.style.preSize) + "px"),
    color: ("" + (_vm.options.style.txtColor)),
  })},[_c('div',{staticClass:"ement_body"},[_vm._v(" "+_vm._s(_vm.options.data.preText)+" "),_c('span',{staticClass:"ement_num",style:({
      color: ("" + (_vm.options.style.numColor)),
      fontSize: ((_vm.options.style.numSize) + "px"),
    })},[_vm._v(_vm._s(Math.floor(_vm.enrollment)))]),_vm._v(" 人 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }